import React from 'react';
import { Link, useParams } from 'react-router-dom';

import { getLeaderBySlug, cvParagraphs } from '../../data/leaders';
import NotFound from '../NotFound';

// Kisi sayfasi. CV metni animasyon/modal arkasinda degil, dogrudan DOM'da
// duruyor; build sirasinda prerender edildigi icin HTML kaynaginda da goruluyor.
const LeaderDetail = () => {
    const { slug } = useParams();
    const leader = getLeaderBySlug(slug);

    if (!leader) return <NotFound />;

    const paragraphs = cvParagraphs(leader);

    return (
        <main className="leader-page">

            <section className="leader-hero">
                <div className="container">

                    <nav aria-label="breadcrumb" className="leader-breadcrumb mb-4">
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/#home-leadership">Leadership Team</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">{leader.name}</li>
                        </ol>
                    </nav>

                    <div className="row align-items-center g-4">
                        <div className="col-12 col-md-auto text-center text-md-start">
                            <img
                                className="leader-hero-img"
                                src={leader.img}
                                alt={`${leader.name}, ${leader.role} at GloworKs`}
                            />
                        </div>
                        <div className="col-12 col-md text-center text-md-start">
                            <h1 className="leader-hero-name">{leader.name}</h1>
                            <p className="leader-hero-role mb-2">{leader.role}</p>
                            <p className="leader-hero-exp mb-0">{leader.exp}</p>
                        </div>
                    </div>

                </div>
            </section>

            <section className="leader-body">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-lg-9">
                            <article className="leader-cv">
                                {paragraphs.map((paragraph, idx) => (
                                    <p key={idx}>{paragraph}</p>
                                ))}
                            </article>

                            <Link to="/#home-leadership" className="btn experienceSeeBtn px-4 py-2 mt-4 leader-back-btn">
                                BACK TO THE TEAM <i className="bi bi-arrow-up-right btn-icon ms-2"></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

        </main>
    );
};

export default LeaderDetail;
